/* eslint-disable */
export default {
  Inbound: '撥入',
  Outbound: '撥出',
  log: '記錄',
  save: '儲存並建立',
  discard: '捨棄並建立',
  hangup: '掛斷',
  reject: '至語音信箱',
  saveDraftAndCreateNewLog: '儲存草稿並建立新的通話記錄',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
